import _ from 'lodash';
import PmsExporter, { ImagesType, PMSConfigurationType, StudyType } from './PmsExporter';
import { Patient } from 'app/interfaces/Patient';

export namespace AssistoVet {
  export const ORIGIN = 'AssistoVet';
  export const CONFIGURATION_KEY = 'assisto_vet';
  export const LABEL = ORIGIN;
  export const DEFAULT_SPECIES_ALIASES = {
    RON: 'rodent',
    CN: 'dog',
    CT: 'cat',
    AUT: 'other',
    P: 'other',
    REP: 'reptile',
    OIS: 'bird',
    LAP: 'rabbit',
    CN2: 'dog',
    BV: 'other',
    CV: 'other',
    PC: 'other',
    OV: 'other',
    CP: 'other',
  } as const;
}
export default class AssistoVetExporter extends PmsExporter {
  exportDataToPMS = async (
    { exportDirectory }: PMSConfigurationType = {},
    currentStudy: StudyType,
    patient: Patient,
    images: ImagesType = []
  ): Promise<PromiseSettledResult<void>[]> => {
    // PMS not configured, don't bother user with this
    if (!exportDirectory) {
      console.warn('exportDirectory is not configured cannot export data to PMS');
      return undefined;
    }

    const pmsId: string = currentStudy?.pms_id;
    if (!pmsId) {
      console.warn('Patient pms_id is required to export data to PMS');
      return undefined;
    }

    return Promise.allSettled([
      ...this.exportImages(exportDirectory, pmsId, images),
      this.exportReportPdfWithElectron(exportDirectory, pmsId, currentStudy, patient, images),
    ]);
  };
}
